export { default } from './TaxIdInput';
export type { TaxIdInputProps } from './TaxIdInput';
